<template>
  <div class="about">
    <div class="headBox">
      <div class="head">
        <img
          src="../assets/images/items/item2/quit.png"
          alt=""
          @click="goHome"
          class="img1"
        />
      </div>
    </div>

    <div class="head-img">
      <img src="../assets/images/items/item2/headImg.png" alt="" />
    </div>
    <div class="head-content">
      <!-- <div class="title">
        <img src="../assets/images/items/item2/title.png" alt="" />
      </div> -->
      <!-- <div class="icon">
        <img src="../assets/images/items/item2/timePlace.png" alt="" />
      </div>
      <div class="content">
        <img src="../assets/images/items/item2/introduce.png" alt="" />
      </div> -->

      <div class="text-title">
        <h2 class="font-bold l-s-75">高安市瑞州府衙展陈</h2>
      </div>

      <div class="text-icon">
        <img src="../assets/images/items/item1/icon.png" alt="" class="img" />
        <span class="didian font-regular l-s-75">北京</span>
        <span class="time font-regular l-s-75">2021</span>
      </div>

      <div class="text-content">
        <p class="font-light l-s-75">
         瑞州府衙遗址博物馆是在府衙遗址上复原的“府衙”建筑群，为高安市元青花文旅融合示范区核心项目之一，博物馆深度融合了建筑功能、地方文化、名人故事等，全面展示了中国府衙文化的博大与精深。
        </p>
        <p class="font-light l-s-75">
         展陈设计风格宏大、简约而质朴，利用大空间优势，在展示手法上注重突出地域文化风格和历史背景，以瑞州府衙文化为载体，将图文展板和壁面场景相结合，场景复原与高科技手段相结合，饱满、生动地展现出瑞州府衙文化。
        </p>
        <p class="font-light l-s-75">
         在确立博物馆展陈特色的基础上，我们坚持融合创新，运用现代科技增强博物馆的整体艺术效果。传统展陈与新媒体手段充分结合，展览展示与文创演艺交融互补，打造沉浸式、个性化文旅体验新场景。
        </p>
      
      </div>

      <div class="roam">
        <img
          src="../assets/images/items/item2/panoramicRoaming.png"
          alt=""
          @click="goRoam('RZFY')"
        />
      </div>
    </div>

    <div class="items">
      <div class="item">
        <div class="title">
         <p class="font-regular l-s-75"> &nbsp;</p>
           <!-- <p class="font-regular l-s-75 test-title"> 展现名 </p> -->
        </div>
        <div class="content">
          <div class="video">
            <img src="../assets/images/items/item2/jgtx.jpg" alt="" />
            <video
              src="../assets/images/items/item2/jgtx.mp4"
              controls
              webkit-playsinline="true"
              playsinline="true"
              poster="../assets/images/items/item2/video2.jpg"
            ></video>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <!-- <img src="../assets/images/items/item2/展项名称.png" alt="" class="img-title">
          <img src="../assets/images/items/item2/展项介绍.png" alt="" class="img-content"> -->
          <p class="font-regular l-s-75 test-title">  </p>
        </div>
        <div class="content">
          <div class="video">
            <div class="week">
              <img
                src="../assets/images/items/item2/week.png"
                alt=""
                @click="goVideo('RZvideo')"
              />
            </div>
            <video
              src="../assets/images/items/item2/fyqn.mp4"
              controls
              webkit-playsinline="true"
              playsinline="true"
              poster="../assets/images/items/item2/video1.jpg"
            ></video>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/glze.jpg" alt="" />
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75 test-title">  </p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/jiang.jpg" alt="" />
              <video
                src="../assets/images/items/item2/jiang.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video3.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
           <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/qnfg.jpg" alt="" />
              <img src="../assets/images/items/item2/qnfg01.jpg" alt="" />
              <video
                src="../assets/images/items/item2/qnfg.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video4.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
           <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <video
                src="../assets/images/items/item2/rzqn.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video5.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
           <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/rzsj.jpg" alt="" />
              <img src="../assets/images/items/item2/rzsj01.jpg" alt="" />
              <video
                src="../assets/images/items/item2/rzsj.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video6.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/rzwf01.jpg" alt="" />
              <video
                src="../assets/images/items/item2/rzwf.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video7.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/shu.jpg" alt="" />
              <video
                src="../assets/images/items/item2/shu.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video8.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
            <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <video
                src="../assets/images/items/item2/shushi.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video9.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title"> 
            <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <video
                src="../assets/images/items/item2/new.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video10.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75"> &nbsp;</p>
          </div>
          <div class="content">
            <div class="video">
              <video
                src="../assets/images/items/item2/yjfs.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video11.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
              <p class="font-regular l-s-75 test-title">  </p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/yuan.jpg" alt="" />
              <video
                src="../assets/images/items/item2/yuan.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video12.jpg"
              ></video>
              <video
                src="../assets/images/items/item2/yuan01.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video13.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
             <p class="font-regular l-s-75 test-title">  </p>
          </div>
          <div class="content">
            <div class="video">
              <img src="../assets/images/items/item2/zuo.jpg" alt="" />
              <video
                src="../assets/images/items/item2/zuo.mp4"
                controls
                webkit-playsinline="true"
                playsinline="true"
                poster="../assets/images/items/item2/video14.jpg"
              ></video>
            </div>
          </div>
        </div>

        <div class="item">
          <div class="title">
            <!-- <img src="../assets/images/items/item2/展项名称.png" alt="" class="img-title">
          <img src="../assets/images/items/item2/展项介绍.png" alt="" class="img-content"> -->
            <p class="font-regular l-s-75 test-title">  </p>
          </div>
          <div class="content">
            <img src="../assets/images/items/item2/fydg.jpg" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="home-footer">
      <img src="../assets/images/part5/logo.png" alt="" />
    </div>
  </div>
</template>

<script >
import store from "../store";
import { mapState, mapMutations } from "vuex";
export default {
  name: "About",
  data() {
    return {};
  },
  computed: {
    ...mapState(["aboutData"]),
  },
  methods: {
    ...mapMutations(["setAboutScrolltop"]),
    goHome() {
      this.$router.replace("/");
    },
    goVideo(data) {
      this.$router.replace({
        name: "Video",
        params: {
          video: data,
          about: this.$route.params.id,
        },
      });
    },
    goRoam(data) {
      this.$router.replace({
        name: "Roam",
        params: {
          name: data,
          about: this.$route.params.id,
        },
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(() => {
        let bodySrcollTop = document.body.scrollTop;
        if (bodySrcollTop || bodySrcollTop == 0) {
          document.body.scrollTop = store.state.aboutData.scrollTop;
        }
        let docSrcollTop = document.documentElement.scrollTop;
        if (docSrcollTop || docSrcollTop == 0) {
          document.documentElement.scrollTop = store.state.aboutData.scrollTop;
        }
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    // window.removeEventListener('scroll', this.windowScroll)
    // console.log(this.scrollTop);
    // this.setHomeScrolltop(this.scrollTop);
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;

    if (to.name == "Video" || to.name == "Roam") {
      this.setAboutScrolltop(scrollTop);
    } else if (to.name == "Home") {
      this.setAboutScrolltop(0);
      // 这里可以写销毁组件
    }
    next();
  },
  mounted() {
    // console.log(111);
    let videos = document.querySelectorAll(".about video");
    // console.log(videos);
    for (let i = 0; i < videos.length; i++) {
      videos[i].addEventListener("play", function () {
        for (let j = 0; j < videos.length; j++) {
          if (videos[j] != this) {
            videos[j].pause();
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.about {
  width: 100vw;
  max-width: 750px;
  margin: 0 auto;
  background-color: black;
}

.headBox {
  height: 0.6rem;
  width: 100%;
}

.head {
  width: 100vw;
  max-width: 750px;
  margin: 0 auto;
  height: 0.6rem;
  background-image: url("../assets/images/items/item2/head.png");
  background-size: cover;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  z-index: 999;
}

.head img {
  width: 1.18rem;
  height: 0.48rem;

  margin-top: 0.06rem;
}

.head .img1 {
  float: left;
  margin-left: 0.12rem;
}
.head .img2 {
  float: right;
  margin-right: 0.12rem;
}

.head-img {
  width: 100%;
}
.head-img img {
  width: 100%;
}

.head-content {
  width: 100%;
}

.head-content .title {
  width: 80%;
  margin: 0 auto;
}
.head-content .title img {
  width: 100%;
}

.head-content .icon {
  width: 30%;
  margin: 0 auto;
}
.head-content .icon img {
  width: 100%;
}
.head-content .content {
  width: 75%;
  margin: 0 auto;
  margin-top: 0.36rem;
}
.head-content .content img {
  width: 100%;
}

.head-content .roam {
  width: 25%;
  margin: 0 auto;
  margin-top: 0.18rem;
}
.head-content .roam img {
  width: 100%;
}

.items {
  width: 100%;
  margin-top: 0.95rem;
}

.items .item {
  margin-top: 0.24rem;
}
.items .item .title {
  text-align: left;
}
.items .item .title img {
  margin-left: 10%;
}
.items .item .title .img-title {
  width: 60%;
}
.items .item .title .img-content {
  width: 70%;
  margin-top: 0.12rem;
}

.items .item .title p {
  /* width: 80%; */
  font-size: 0.19rem;
  color: #fff;
  margin-left: 10%;
}
.items .item .content {
  text-align: center;
}
.items .item .content img {
  /* max-width: 100%; */
  /* max-height: 100px; */
  width: 100%;
  margin-top: 0.12rem;
}

.items .item .content .video {
  position: relative;
}

.items .item .content .video .week {
  position: absolute;
  top: 0.12rem;
  right: 0.12rem;
  z-index: 300;
}

.items .item .content .video .week img {
  width: 0.59rem;
  cursor: pointer;
}

.items .item .content video {
  width: 100%;
  margin-top: 0.12rem;
}

/* 文字替换图片 */
.head-content .text-title{
  color: #fff;
  margin-top: 0.36rem;;
  font-size: 0.24rem;

}
.head-content .text-icon{
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  margin-top: 0.18rem;;
  
}
.head-content .text-icon .img{
  width: 0.24rem;
}
.head-content .text-icon .didian{
  margin-right: 0.24rem;
}
.head-content .text-content {
  color: #fff;
  margin-top: 0.4rem;
  padding: 0 0.25rem;
   font-size: 0.16rem;
   text-align: left;
   text-indent:2em
}
.head-content .text-content p{
  margin-bottom: 0.08rem;
}

/* 字体样式 */
.items .test-title{
     border-left: 0.05rem solid #FFF;
    padding-left: 0.05rem;
}

.l-s-75{
   letter-spacing:2.5px
}



.items .item .title p{
  font-size: 0.25rem;
}

/* 页尾 */
.home-footer {
  width: 100%;
  background-color: black;
  padding-top: 0.5rem;
  padding-bottom: 0.1rem;
  text-align: left;
}

.home-footer img {
  width: 50%;
  margin-left: 0.3rem;
}


</style>
